export enum eAssignmentGroup {
  Quizzes = 1,
  Assignments = 2,
  Exams = 3,
  Projects = 4,
}
